<template>
  <form class="my-5 mx-5">
    <b-row>
      <b-col cols="6">
        <b-form-group id="name" :label="$t($getConst.pages.scope.name)" label-for="name-input">
          <b-form-input
            id="name-input"
            v-model.trim="$v.scope.name.$model"
            :class="{ 'is-invalid': $v.scope.name.$error || scopeExist }"
            :placeholder="$t(this.$getConst.pages.scope.enter_name)"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.scope.name"/>
          <b-form-invalid-feedback v-if="scopeExist">
            {{$t(this.$getConst.pages.form.exist_field_error)}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="status" :label="$t($getConst.pages.scope.status)" label-for="status-input">
          <multiselect
            v-model="$v.scope.status.$model"
            :class="{ 'is-invalid': $v.scope.status.$error }"
            :placeholder="$t(this.$getConst.pages.form.select_option)"
            :options="status"
            :show-labels="false"
            :searchable="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <b-badge
                class="gradient"
                pill
                :variant="(props.option === 'work' || props.option === 'live') ? 'secondary' : 'warning'"
                style="width:50%;">{{$t($getConst.pages.scope[props.option])}}</b-badge>
            </template>
            <template slot="option" slot-scope="props">
              <b-badge
                class="gradient"
                pill
                :variant="(props.option === 'work' || props.option === 'live') ? 'secondary' : 'warning'"
                style="width:50%;">{{$t($getConst.pages.scope[props.option])}}</b-badge>
            </template>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.status"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group id="languages" :label="$t($getConst.pages.scope.languages)" label-for="scope-input">
          <multiselect
            v-model="$v.scope.languages.$model"
            :class="{ 'is-invalid': $v.scope.languages.$error }"
            track-by="id"
            label="name"
            :placeholder="$t(this.$getConst.pages.form.select_option)"
            :options="languages"
            :multiple="true"
            :show-labels="false"
            :close-on-select="false"
            @input="onChangeLanguages"
          >
            <template slot="option" slot-scope="props">
              <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
              {{$t(props.option.name.toLowerCase()) | capitalize}}
            </template>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.languages"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="default-language" :label="$t($getConst.pages.scope.default_language)" label-for="default-language-input">
          <multiselect
            v-model="$v.scope.language_id.$model"
            :class="{ 'is-invalid': $v.scope.language_id.$error || languageExistInList}"
            track-by="id"
            label="name"
            :placeholder="$t(this.$getConst.pages.form.select_option)"
            :options="$v.scope.languages.$model"
            :show-labels="false"
            :searchable="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
              {{$t(props.option.name) | capitalize}}
            </template>
            <template slot="option" slot-scope="props">
              <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
              {{$t(props.option.name.toLowerCase()) | capitalize}}
            </template>
          </multiselect>
          <AppFormFeedback :errors="$v.scope.language_id"/>
          <b-form-invalid-feedback v-if="languageExistInList">
            {{$t(this.$getConst.pages.form.notAssigned_language_error)}}
          </b-form-invalid-feedback>

        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="nav_scope_id" :label="$t($getConst.pages.scope.nav_scope_id)" label-for="nav_sharedKey-input">
          <b-form-input
            id="nav_scope_id-input"
            v-model.trim="$v.scope.nav_scope_id.$model"
            :class="{ 'is-invalid': $v.scope.nav_scope_id.$error || scope_nav_id_Exist}"
            :placeholder="$t(this.$getConst.pages.scope.enter_nav_scope_id)"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.scope.nav_scope_id"/>
          <b-form-invalid-feedback v-if="scope_nav_id_Exist">
            {{$t($getConst.pages.scope.scope_nav_exist)}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group id="portal-url" :label="$t($getConst.pages.scope.portal_url)" label-for="portal-url-input">
          <b-form-input
            id="portal-url-input"
            v-model.trim="$v.scope.portal_url.$model"
            :class="{ 'is-invalid': $v.scope.portal_url.$error  }"
            :placeholder="$t(this.$getConst.pages.scope.portal_url)"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.scope.portal_url"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group id="timezone" :label="$t($getConst.pages.scope.timezone)" label-for="timezone-select">
          <multiselect
                id="timezone-select"
                v-model="$v.scope.timezone.$model"
                :class="{ 'is-invalid': $v.scope.timezone.$error }"
                :placeholder="$t($getConst.pages.form.select_option)"
                :options="timezonesList"
                :show-labels="false"
                :close-on-select="true"
              >
          </multiselect>
          <AppFormFeedback :errors="$v.scope.timezone"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <label>{{ $t($getConst.pages.scope.application_options) }}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="checkbox">
        <b-form-checkbox class="d-inline" switch v-model="$v.scope.is_timesheets_enabled.$model" size="lg" :disabled="scope.is_timesheets_enabled && !scope.is_invoices_enabled">
          <label>{{$t($getConst.pages.scope.is_timesheets_enabled)}}</label>
        </b-form-checkbox>
      </b-col>

      <b-col cols="6" class="checkbox">
        <b-form-checkbox class="d-inline is-invalid" switch v-model="$v.scope.is_invoices_enabled.$model" size="lg" :disabled="scope.is_invoices_enabled && !scope.is_timesheets_enabled">
        </b-form-checkbox>
        <label>
          {{$t($getConst.pages.scope.is_invoices_enabled)}}
        </label>
      </b-col>
    </b-row>

    <div class="text-danger" v-if="applicationOptionsError">
      {{ $t($getConst.pages.scope.application_options_error) }}
    </div>

  </form>
</template>

<script>
  import {required, integer, minValue} from "vuelidate/lib/validators";
  import {addScope, editScope, getTimezonesList} from "../../../api/scopes.api";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import AppSection from "../../../components/common/sections/AppSection";
  import AppSpinner from "../../../components/common/utils/AppSpinner";

  const matchUrl=(value) =>
    value ?value.split(":")['0'] === "http" ||  value.split(":")['0'] === "https":true;

  export default {
    name: "ScopeForm",
    components: {AppSpinner, AppFormFeedback, AppSection},
    props: {
      modal_id: null,
      scopeToEdit: null,
      languages: null,
    },
    data() {
      return {
        isLoadScope: false,
        isLoading: false,
        newState:null,
        test:null,
        scopeExist: false,
        scope_nav_id_Exist: false,
        languageExistInList: false,
        action: 'add',
        language: null,
        scope: {
          name: null,
          status: null,
          language_id: null,
          nav_scope_id: null,
          portal_url: null,
          languages: [],
          is_timesheets_enabled: true,
          is_invoices_enabled: false,
          timezone: ''
        },
        scopeLanguages: [],
        status: [this.$getConst.pages.scope.live, this.$getConst.pages.scope.maintenance],
        isSubmited: false,
        listOfLanguages: this.languages,
        timezonesList: [],
        applicationOptionsError: false
      }
    },

    validations: {
      scope: {
        name: {required},
        status: {required},
        language_id: {required},
        nav_scope_id: {required, integer, minValue: minValue(1)},
        languages: {required},
        is_timesheets_enabled: {required},
        is_invoices_enabled: {required},
        portal_url: {required, matchUrl},
        timezone: {required}
      },
    },
    created() {
      if (this.scopeToEdit) {
        this.action = 'edit';
        this.scope = this.scopeToEdit;
      }
      this.getTimezonesListData();
    },
    mounted() {
      this.$root.$on('isSubmited', submit => {
        this.isSubmited = submit;
      });
    },
    methods: {
      closeModal() {
        this.$bvModal.hide(this.modal_id)
      },
      updateScope() {
        let scope = Object.assign({}, this.scope);
        scope.language_id = this.scope.language_id.id;
        scope.languages = this.scope.languages.map(language => {
          return language.id;
        });
        return scope;
      },
      isFormInvalid() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return true;
        }
        return false
      },
      errorFromServerTreatment(error){
        if (error.response.data.code === 422) {
          this.scopeExist = 'name' in error.response.data.error;
          this.scope_nav_id_Exist = 'nav_scope_id' in error.response.data.error;
          this.languageExistInList = 'default_language' in error.response.data.error;
          this.applicationOptionsError = 'is_timesheets_enabled' in error.response.data.error || 'is_invoices_enabled' in error.response.data.error;
        }
        this.$root.$emit('isLoading', false);
        this.isSubmited = false;
      },
      formValidTreatment() {
        this.$root.$emit('isLoading', true);
        this.scopeExist = false;
        this.scope_nav_id_Exist = false;
        this.applicationOptionsError = false;
      },
      addScope() {
        if (this.isFormInvalid()) {
          return;
        }
        this.formValidTreatment();
        addScope(this.updateScope()).then(
          res => {
            this.$root.$emit('onAddScope', res.data);
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
            this.closeModal();
          },
          error => {
            this.errorFromServerTreatment(error);
          }
        )
      },
      editScope() {
        if (this.isFormInvalid()) {
          return;
        }
        this.formValidTreatment();
        editScope(this.scopeToEdit.id, this.updateScope()).then(
          res => {
            if (res.data.id == this.$store.getters["auth/scopeDefault"].id) {
              this.newState = JSON.parse(localStorage.getItem("userAccount"));
              this.newState.scopeDefault = res.data;
              localStorage.setItem("userAccount", JSON.stringify(this.newState));
              this.$store.dispatch("auth/setUserAccountAction", this.newState);
            }
            this.$root.$emit('onEditScope', res.data);
            this.$root.$emit('isLoading', false);
            this.closeModal();

          },
          error => {
           this.errorFromServerTreatment(error);
          }
        )
      },
      onChangeLanguages() {
        if (!this.scope.languages.includes(this.scope.language_id)) {
          this.scope.language_id = null;
        }
      },
      getTimezonesListData() {
        getTimezonesList().then(
          res => {
            this.timezonesList = res.data
          }
        );
      }
    },
    watch: {
      isSubmited: function () {
        if(this.isSubmited) {
          if (this.scopeToEdit) {
            this.editScope();
          } else {
            this.addScope();
          }
        }

      }
    }
  }
</script>

<style scoped>
  .checkbox {
        padding: 1%;
  }
</style>
